/**
 * The two answers to "how did your clinic tell you to inject it", as one table.
 *
 * A label and the route it selects, side by side, because they were two lists
 * that had to agree and nothing made them: the button read its text from one
 * catalogue key and passed its route from a handler written beside it, and a
 * test asserted the keys named the right sites from a copy of the pairing it
 * kept itself. Swap the two handlers and every test stays green while a button
 * reading "Into the muscle (buttock)" starts the abdominal walk.
 *
 * Here the label and the route are the same row. The question renders the table
 * and `route-question.test.ts` asserts against it, so the pairing is stated
 * once and read by both.
 */
export const ROUTE_CHOICES = [
  {
    route: "intramuscular",
    labelKey: "route_into_the_muscle",
    testID: "injection-coach-route-intramuscular",
  },
  {
    route: "subcutaneous",
    labelKey: "route_under_the_skin",
    testID: "injection-coach-route-subcutaneous",
  },
] as const satisfies readonly {
  route: "intramuscular" | "subcutaneous";
  labelKey: string;
  testID: string;
}[];
